// import { men } from "../data/db.json";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import BeatLoader from "react-spinners/BeatLoader";
import { useState, useEffect } from "react";
import Navbar from "./Navbar";
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const TypeWise = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { type } = useParams();
  const Sidebar = () => {
    return (
      <div className="sidebar" style={{ width: "15%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "15px 25px",
            textTransform: "uppercase",
            fontWeight: "600",
          }}
        >
          <div>Filters</div>
          <div style={{ color: "indigo" }}>Clear All</div>
        </div>{" "}
        <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            categories
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox" /> Tshirts
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Shirts
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Shorts
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Shoes
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Kurtas
              </label>
            </li>
          </ul>
        </div>
        <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            Brand
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox" /> Roadster
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Wrogn
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Nike
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Adidas
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Tommy Hilfiger
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> HRX by Hrithik Roshan
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Only
              </label>
            </li>
          </ul>
        </div>
        <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            Price
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox" /> Rs. 199 to Rs. 1149
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 1149 to Rs. 2099
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 2099 to Rs. 3049
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> Rs. 3049 to Rs. 3999
              </label>
            </li>
          </ul>
        </div>
        <div style={{ border: "1px solid #E9E9ED", padding: "15px 25px" }}>
          <div
            style={{
              marginBottom: "0px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}
          >
            Discount Range
          </div>
          <ul>
            <li>
              <label>
                <input type="checkbox" /> 10% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> 20% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> 30% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> 40% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> 50% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> 60% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> 70% and above
              </label>
            </li>
            <li>
              <label>
                <input type="checkbox" /> 80% and above
              </label>
            </li>
          </ul>
        </div>
      </div>
    );
  };

  useEffect(() => {
    axios.get(SERVER_URL + "/api/products").then((res) => {
      setTimeout(() => {
        setProducts((prev) => res.data);
        setLoading(false);
      }, 100);
      // console.log(products);
    });
  }, [type]);


  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "black",
  };



  return (
    <>
      <Navbar />
      <div className="men" style={{ marginTop: "6rem" }}>
        <div style={{ display: "flex" }}>
          <Sidebar></Sidebar>
          {loading ?
            <div className="main-Content-1" style={{ width: "85%", marginTop: "10%" }}>
              <BeatLoader
                color="#00bcf2"
                loading={loading}
                cssOverride={override}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </div>
            :
            <div className="main-Content" style={{ width: "85%" }}>
              {products &&
                products
                  .filter(function (product) {
                    return (product.pCategory.cName).toLowerCase() === type;
                  })
                  .map((product) => (
                    <div className="inner CC">
                      <div class="productRatingsContainer">
                        <span>4.7</span>
                        <span class="myntraweb-sprite starIcon index-productRatingsGoodIcon RatingsGoodIcon"></span>
                        <div class="ratingsCount">
                          <div class="separator">|</div>15.7k
                        </div>
                      </div>
                      <Link
                        to={`/product/${product._id}`}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        <div className="content">
                          <img
                            src={SERVER_URL + `/uploads/products/${product.pImages[0]}`}
                            className="card-img-top"
                            alt="..."
                          />
                          <div className="card-body">
                            <h6
                              className="card-title"
                              title={`${product.pName}`}
                              style={{ textAlign: "start", marginBottom: "5px" }}
                            >
                              {product.pName}
                            </h6>
                            <p className="brand-name">{product.pDescription}</p>
                            <h6 className="brand-name">
                              <span>
                                <strong>₹{Math.floor(product.pPrice * (100 - product.pOffer) / 100)}</strong>
                              </span>
                              <span style={{ fontWeight: 400, marginLeft: "8px", fontSize: "12px", opacity: "0.8", lineHeight: 1.2 }}>
                                <s>Rs.{product.pPrice}</s>
                              </span>
                              <span style={{
                                fontWeight: 500, marginLeft: "8px", fontSize: "12px",
                                letterSpacing: ".5px",
                                color: "#ff905a"
                              }}>
                                ({product.pOffer}% OFF)
                              </span>
                            </h6>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default TypeWise;
